import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, PageEvent} from '@angular/material';
import {AirportService} from '../../airport/airport.service';
import {AirportSearchResult} from '../../airport/models/airport-search-result.model';
import {Business} from '../models/business.model';
import {BusinessManagerService} from '../../shared/user/business-manager.service';
import {Airport} from '../../airport/models/airport.model';


@Component({
  selector: 'app-edit-add-airport',
  templateUrl: './edit-add-airport.component.html',
  styleUrls: ['./edit-add-airport.component.scss']
})
export class EditAddAirportComponent implements OnInit {

  business: Business;
  _airportFilter = '';
  _searchPrivateAirports = false;
  isLoading = false;
  searchedAirports: AirportSearchResult[];
  currentPage: AirportSearchResult[];
  pageLength = 5;


  constructor(public dialogRef: MatDialogRef<EditAddAirportComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private airportService: AirportService,
              private _businessService: BusinessManagerService,
              public snackBar: MatSnackBar) {
    this.business = data.business;
  }

  ngOnInit() {
  }

  get airportFilter(): string {
    return this._airportFilter;
  }

  set airportFilter(newFilter: string) {
    this._airportFilter = newFilter;
    this.loadAirports();
  }

  get searchPrivateAirports(): boolean {
    return this._searchPrivateAirports;
  }

  set searchPrivateAirports(newFilter: boolean) {
    this._searchPrivateAirports = newFilter;
    this.loadAirports();
  }

  loadAirports(): void {
    if (this.airportFilter.length >= 3) {
      this.isLoading = true;
      this.currentPage = [];
      this.airportService.getAirportsBySearchTerm(this.airportFilter, this.searchPrivateAirports)
        .then((airportList) => {
          this.searchedAirports = airportList;
          this.isLoading = false;
          this.doPageEvent({
            pageIndex: 0,
            pageSize: this.pageLength,
            length: this.searchedAirports.length
          });
        })
        .catch((error) => console.log(error));
    }
  }

  async onAdd(airport: Airport): Promise<void> {
    const responseString = await this._businessService.addAssociatedAirport(this.business, airport.airportId);
    if (responseString.includes('added to')) {
      this.snackBar.open(`Added ${airport.faaId} to ${this.business.name}`, 'Close', {
        duration: 5000
      });
      this.business = await this.airportService.getBusiness(this.business.id.toString());
    } else {
      if (responseString.includes('already associated with')) {
        this.snackBar.open(`${airport.faaId} already associated with ${this.business.name}`, 'Close', {
          duration: 5000
        });
      } else {
        this.snackBar.open(`Failed to Add ${airport.faaId} to ${this.business.name}`, 'Close', {
          duration: 5000
        });
      }
    }
  }

  doPageEvent(event: PageEvent): void {
    const start = event.pageIndex * event.pageSize;
    this.currentPage = this.searchedAirports.slice(start, start + event.pageSize);
  }
}
